import AxiosCustom from "./../../../components/common/apiConfigPouyan/index";


export function get_panel(payload) {

  const config = {
    url: `/TradingSystem/GetAllTradingSystems/GetAll/${payload?.data?.nationalCode}`,
    method: 'GET'
  };
  const data = {};

  const header = {
    ...payload?.headers
  }

  return AxiosCustom(config, data, header);
}
